import styled from 'styled-components';

const defaultRadius = '1.2em';

export const ColoredCircle = styled.div<{ color: string | undefined; noFill?: boolean; radius?: string }>`
  background-color: ${props => (props.noFill ? 'transparent' : props.color)};
  width: ${props => props.radius ?? defaultRadius};
  height: ${props => props.radius ?? defaultRadius};
  flex-shrink: 0;
  flex-grow: 0;
  border: 2px solid ${props => props.color};
  border-radius: 50%;
  display: inline-block;
  vertical-align: text-bottom;
`;
